module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-bottom-ties-remnants.79d2269b.png";